import React from "react";

const ROLE_BADGE_CLASS = {
  admin: "bg-jm1",
  manager: "bg-jm3",
  employee: "bg-sm",
};

/**
 * Read-only user table inside the Users modal.
 */
export default function UserList({ users, currentUserId, onEdit, onDelete }) {
  return (
    <div
      style={{
        maxHeight: 240,
        overflow: "auto",
        marginBottom: 14,
        border: "1px solid #E0E0E0",
        borderRadius: 8,
      }}
    >
      <table style={{ width: "100%", fontSize: 12 }}>
        <thead>
          <tr style={{ background: "#F5F7FA" }}>
            <th style={{ textAlign: "left", padding: "8px 10px" }}>Email</th>
            <th style={{ textAlign: "left", padding: "8px 10px" }}>Name</th>
            <th style={{ textAlign: "left", padding: "8px 10px" }}>Role</th>
            <th style={{ textAlign: "left", padding: "8px 10px" }}>Linked Emp</th>
            <th style={{ textAlign: "right", padding: "8px 10px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan={5} style={{ textAlign: "center", padding: 16, color: "#666" }}>
                No users
              </td>
            </tr>
          ) : null}
          {users.map((u) => (
            <tr key={u.id} data-testid={`user-row-${u.email}`}>
              <td style={{ padding: "6px 10px", fontWeight: 600 }}>
                {u.email}
                {u.id === currentUserId ? (
                  <span
                    style={{
                      marginLeft: 6,
                      fontSize: 10,
                      background: "#EEF3FA",
                      color: "#1a3c6e",
                      padding: "1px 6px",
                      borderRadius: 4,
                    }}
                  >
                    you
                  </span>
                ) : null}
              </td>
              <td style={{ padding: "6px 10px" }}>{u.name}</td>
              <td style={{ padding: "6px 10px" }}>
                <span className={`badge ${ROLE_BADGE_CLASS[u.role] || "bg-sm"}`}>{u.role}</span>
              </td>
              <td style={{ padding: "6px 10px", fontSize: 11, color: "#666" }}>
                {u.employee_id || "—"}
              </td>
              <td style={{ padding: "6px 10px", textAlign: "right" }}>
                <button
                  className="btn btn-sm"
                  onClick={() => onEdit(u)}
                  data-testid={`edit-user-${u.email}`}
                >
                  <i className="ti ti-edit"></i>
                </button>
                {u.id !== currentUserId ? (
                  <button
                    className="btn btn-sm btn-del"
                    style={{ marginLeft: 4 }}
                    onClick={() => onDelete(u)}
                    data-testid={`delete-user-${u.email}`}
                  >
                    <i className="ti ti-trash"></i>
                  </button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
